import { post } from "@/utils";
import { computed, isRef, ref, unref, watchEffect } from "vue";

export function usePost<TReturnData>(
  url: string,
  defValue: () => TReturnData,
  postData?: any
) {
  const data = ref<TReturnData>();

  async function doPost() {
    // 在请求之前重设状态...
    data.value = undefined;
    // unref() 解包可能为 ref 的值
    const paramData = postData ? unref(postData) : {};
    const { data: retData } = await post(url, paramData);
    data.value = retData;
  }

  if (isRef(postData)) {
    watchEffect(doPost);
  } else {
    doPost();
  }

  return { data: computed(() => data.value ?? defValue()) };
}
